// Section 17 and 18: Announce rations policy. Announced orders halve the trust penalty for those
// rationed short (they knew the rule) but make any deviation from the order cost double;
// hidden orders keep the full penalty. Switching to Off costs trust -3 (Section 18).
// Constants: config.trust.rationedShortAnnouncedMul, config.rationing.announcedDeviationMul,
// config.policies.announceOffTrust. Default: config.policies.defaults.announceRations.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { noProblem } from '../../core/content-helpers';
import { definePolicy } from '../../core/registry';

export function announceRations(config: Config) {
  return definePolicy({
    id: 'announceRations',
    label: 'Announce rations',
    section: 'S18',
    group: 'rations',
    options: [true, false],
    default: config.policies.defaults.announceRations,
    modifierTargets: ['trustChange'],
    modifierKeys: { trustChange: ['rationed-short', 'rationed-short-deviation'] },
    modifiers(ctx, target) {
      if (target.kind !== 'trustChange' || !ctx.state.policies.announceRations) return [];
      if (target.cause === 'rationed-short')
        return [
          mod.mul('policy:announceRations', ctx.cfg.trust.rationedShortAnnouncedMul, 'announced'),
        ];
      if (target.cause === 'rationed-short-deviation')
        return [
          mod.mul(
            'policy:announceRations',
            ctx.cfg.rationing.announcedDeviationMul,
            'deviation from the announced order',
          ),
        ];
      return [];
    },
    changeCost: (from, to) => (from && !to ? config.policies.announceOffTrust : 0),
    affects: (_ctx, on) => [
      {
        key: on ? 'policy.announceRations.on' : 'policy.announceRations.off',
        params: {
          short: Math.round(config.trust.rationedShort * config.trust.rationedShortAnnouncedMul),
          deviation: Math.round(
            config.trust.rationedShort * config.rationing.announcedDeviationMul,
          ),
          hidden: config.trust.rationedShort,
        },
      },
    ],
    validate: noProblem,
  });
}
